'use client';
import styles from './styles.module.scss';
import Link from '@/components/WrappedLink';
import { useAnalytics } from '@/integrations';
import Typography from '@/components/shared/typography/typography.component';
import { useTranslation } from '@/hook';

export default function CalculateFinanceButton() {
    const { t, i18n } = useTranslation();
    const { trackEvent } = useAnalytics();
    return (
        <Link
            href={`/${i18n.language}/car-finance`}
            style={{ marginTop: 'auto' }}
            onClick={() => {
                trackEvent('Screen: Financing Page', {
                    sourceScreen: 'All Cars Listing',
                });
            }}
        >
            <button className={styles.finance_car}>
                <Typography variant={'body2Medium'}>
                    {t('FinanceEntryPoint.calculate')}
                </Typography>
            </button>
        </Link>
    );
}
